export default __webpack_public_path__ + "static/signup-banner-160ba23fba3fbdb6ad52af27bcdd84db.png";